<template>
  <header v-bind:class="{ 'header header--bg' : true, 'header--active': switcherTopMenu}">
      <div class="container">
          <div class="header__body">
              <router-link to="/" class="header__logo">
                  <img src="/static/img/logosvadop.png" alt="logo" class="header__logo__img">
              </router-link>

              <div class="header__menu-button">
                  <button v-bind:class="{'menu-button': true, 'menu-button--active': switcherTopMenu }" @click="toggleTopMenu"><span></span></button>
              </div>

              <div class="header__menu" >
                  <nav class="header__nav">
                      <router-link
                        @click.native="toggleTopMenu"
                        class="header__nav__item homepage"
                        v-bind:class="{ 'header__nav__item--active': this.$route.fullPath==='/technology' }"
                        to="/technology"
                      >Technology</router-link>
                      <a class="header__nav__item" href="//client.adop.co/advertiser/login">Login</a>
                  </nav>

                  <div class="header__controls">
                      <a href="//client.adop.co/advertiser/signup" class="button button--rounded button--secondary-otln">See Demo</a>
                  </div>
              </div>
          </div>
      </div>
  </header>
</template>

<script>
import {AUTH_LOGOUT} from '@/store/actions/auth'
import hub from '@/utils/event'
import Swal from 'sweetalert2'

export default {
  name: 'Menu',
  data () {
    return {
      switcherTopMenu: false,
      logget: this.$store.getters.isAuthenticated,
      dropdownAdvertiser: false,
      dropdownCampaign: false,
      dropdownReport: false,
      dropdownPayment: false,
      dropdownList: false,
      username: localStorage.getItem('user-name')
    }
  },
  components: {
    Swal
  },
  created: function () {
    hub.$on('login', this.login)
    hub.$on('logout', this.logout)
    hub.$on('gError', this.gError)
  },
  methods: {
    toggleTopMenu (event) {
      this.switcherTopMenu = !this.switcherTopMenu
      if (this.$route.name === 'Home') {
        if (window.$(event.target).attr('href') === '/') {
          window.$('html,body').scrollTop(window.$('#home').offset().top)
        }
        if (window.$(event.target).attr('href') === '/technology') {
          window.$('html,body').scrollTop(window.$('#technology').offset().top - 40)
        }
      }
    },
    login: function (event) {
      this.logget = true
    },
    logout: function (event) {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$router.push('/')
      })
      this.logget = false
    },
    gError: function (msg) {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        Swal('Warning', 'Something wrong!<br />' + msg, 'warning')
      })
      this.logget = false
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/front/menu.vue